import { TmBaseError } from '@/core/error/tmBaseError'

export class TmComponentCompositionError extends TmBaseError {
  public name = 'TmComponentCompositionError'
}
